import { Component, inject, OnInit, ViewChild, PLATFORM_ID, HostListener, signal, WritableSignal } from '@angular/core';
import { Carousel, CarouselModule } from 'primeng/carousel';
import { FeaturedAuctionsService } from '../../../../services/bidder-community/featured-auctions/featured-auctions.service';
import { AbsoluteMediaUriService } from '../../../../services/absolute-media-uri.service';
import { CommonModule, NgIf, isPlatformBrowser } from '@angular/common';
import { TimeLeftService } from '../../../../services/time-left.service';
import { RouterModule } from '@angular/router';
import { IFeaturedAuctions } from '../../../../models/IFeaturedAuctions';

@Component({
  selector: 'app-featured-auctions',
  imports: [CarouselModule,
    NgIf,
    CommonModule,
    RouterModule
  ],
  templateUrl: './featured-auctions.component.html',
  styleUrl: './featured-auctions.component.scss'
})
export class FeaturedAuctionsComponent implements OnInit {

  private readonly featuredAuctionsService = inject(FeaturedAuctionsService);
  protected readonly absoluteMediaUriService = inject(AbsoluteMediaUriService);
  protected readonly timeLeftService = inject(TimeLeftService);
  private readonly platformId = inject(PLATFORM_ID);

  auctions: WritableSignal<IFeaturedAuctions[]> = signal([]);
  isMobile!: boolean;
  isMobileSmall!: boolean;
  @ViewChild(Carousel) carousel!: Carousel;
  expanded = false;
  responsiveOptions: any[] | undefined;

  ngOnInit(): void {
    this.checkScreenSize();
    this.responsiveOptions = [
      {
        breakpoint: '770px',
        numVisible: 2,
        numScroll: 1
      },
      {
        breakpoint: '575px',
        numVisible: 1,
        numScroll: 1
      }
    ];
    this.featuredAuctionsService.getFeaturedAuctions().subscribe((data) => {
      this.auctions.set(data);
    });
  }

  @HostListener('window:resize', ['$event']) onResize(event: Event) {
    this.checkScreenSize();
  }


  toggleExpanded() {
    this.expanded = !this.expanded;
  }

  private checkScreenSize() {
    if (isPlatformBrowser(this.platformId)) {
      this.isMobile = window.innerWidth < 1190 && window.innerWidth >= 768;
      this.isMobileSmall = window.innerWidth < 768;
    }
  }
}